import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
export const AutomatedAffiliateHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 z-50 w-full transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm py-3' : 'bg-white py-5'}`} data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <div className="flex justify-between items-center" data-id="element-61">
          <div className="flex items-center" data-id="element-62">
            <Link to="/" data-id="element-63">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/3eb2f218-c9ff-4fe6-ad82-ebadfcc155d3/Nf_final.png" alt="Newsfiliate Logo" className="h-8" data-id="element-64" />
            </Link>
          </div>
          <div className="flex items-center" data-id="element-65">
            <button className="px-5 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-all hover:shadow-md" data-id="element-66">
              Join Beta
            </button>
          </div>
        </div>
      </div>
    </header>;
};